import React from "react";
import EstablishmentRequestCard from "./establishment_request_card.component";
import Tooltip from "@material-ui/core/Tooltip";

export const EstablishmentRequestListCard = ({
  userRequest,
  establishmentRequests,
  groupedEstablishmentRequests,
  isCanceled,
  disperseRequest,
  onRemove,
  maxRound,
}) => (
  <div className="req-card-container">
    {groupedEstablishmentRequests.map((g, idx) => (
      <div key={idx}>
        {g.requests.length > 0 && (
          <Tooltip title={g.title ? g.date : ""}>
            <p className="group-requests">
              {g.title ? g.title : "-- Por encaminhar --"}
            </p>
          </Tooltip>
        )}
        {g.requests.map((establishmentRequest, idx) => (
          <EstablishmentRequestCard
            key={establishmentRequest.id}
            userRequest={userRequest}
            onRemove={onRemove}
            isCanceled={isCanceled}
            disperseRequest={disperseRequest}
            id={establishmentRequest.id}
            estValence={establishmentRequest.establishment_valence_id}
            maxRound={maxRound}
          />
        ))}
      </div>
    ))}
  </div>
);
